import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaunchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.5 21H4.5C4.10234 20.9995 3.72112 20.8413 3.43993 20.5601C3.15874 20.2789 3.00054 19.8977 3 19.5V4.5C3.00054 4.10234 3.15874 3.72112 3.43993 3.43993C3.72112 3.15874 4.10234 3.00054 4.5 3H12V4.5H4.5V19.5H19.5V12H21V19.5C20.9995 19.8977 20.8413 20.2789 20.5601 20.5601C20.2789 20.8413 19.8977 20.9995 19.5 21Z",
		fill: "#44C571"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 1.5V3H19.9395L13.5 9.4395L14.5605 10.5L21 4.0605V9H22.5V1.5H15Z",
		fill: "#44C571"
	})]
});
export default SvgLaunchIcon;
